let tableId;
// let filter;
// let search;

var paginationSetting = {
    maxItem : 8,
    currentPage: 1,
    pageNumber: 1
}

function setFilter(prop,value,el){
    el.addClass('active');
    $('.filter-set').not(el).removeClass('active');
    if (value != ''){
        filter = {
            value : value,
            prop : prop
        }
    } else {
        filter.value = false;
    }

    paginationSetting.pageNumber = 1;
    paginationSetting.currentPage = 1;
    reRenderTable();
}

function setSearch(prop,value){
    search = {
        value : value,
        prop : prop
    }
    paginationSetting.pageNumber = 1;
    paginationSetting.currentPage = 1;
    reRenderTable();
}

function vlkTabler(data,model,tableWrapper,paginationSetting,filter) {
    var items = data;
    var filteredItems = undefined;
    var searchedItems = undefined;
    var selectedData = [];
    var selectedKeys = [];
    if (filter.value) {
        filteredItems = [];
        items.map(function(item){
            if (item[filter.prop].toLowerCase() === (filter.value).toLowerCase()){
                filteredItems.push(item)
            }
        })
        items = filteredItems;
    }
    if (search.value !== '' && search.value !== false) {

        searchedItems = []
        items.map(function(item){
            if (item[search.prop].toLowerCase().indexOf((search.value).toLowerCase()) >= 0) {
                searchedItems.push(item)
            }
        })
        items = searchedItems
    }
    if (items.length == 0){
        tableWrapper.innerHTML = '<div class="text-center mt-5"><h3>No Items</h3></div>'
        return
    }
    items.map(function(item,index){
        var newItem = {};
        model.columns.map(function(col){
            switch (col.type) {
                case ('string'):
                    newItem[col.name] = item[col.name];
                    break;
                case ('img'):
                    newItem[col.name] = '<img style="width: 80px" src="' + item[col.name] + '" alt="product-preview">';
                    break;
                case ('function'):
                    newItem[col.name] = window[col.action](item);
                    break;
                case ('numberInput'):
                    newItem[col.name] = `
                        <input class="tabler-input mb-0" type="number" value="${item[col.name]}" onchange="changeAvailables('${item.size}','${item.id}',this)">
                        `
                    break;
                case ('actionBlock'):
                    var actionBlock = '<div class="actionBlock">'
                    col.buttons.map(function(button){
                        actionBlock += `
                        <i id='${item.id}' class="fa ${button.icon}" onClick="${button.function}('${eval(button.agrument)}','${eval(button.agrument2)}',this)" style="cursor: pointer; color: ${button.color}"></i>&nbsp;&nbsp;`
                        ;
                    })
                    actionBlock += '</div>';
                    newItem[col.name] = actionBlock;
                    break;
            }
        })
        selectedData.push(newItem);
    });
    model.columns.map(function(col){
        var colAlias = col.alias;
        selectedKeys.push(colAlias)
    });
    renderTable(selectedKeys,selectedData,tableWrapper,paginationSetting,model)
}

function renderTable(tableKeys,data,wrapper,paginationSetting,model){
    tableId = 'vlkTable-' + (document.getElementsByClassName('table').length + 1);
    var table = '<table id="' + tableId + '" class="table">';
        table +=    '<thead>';
        table +=        '<tr id="' + tableId + '-tHeadRow">';
        table +=        '</tr>';
        table +=    '</thead>';
        table +=    '<tbody id="' + tableId + '-tBody">';
        table +=    '</tbody>';
        table += '</table>';
    wrapper.innerHTML = table;
    tableKeys.map(function(tableKey){
        var th = '<th><p><strong>' + tableKey + '</strong></p></th>';
        var tr = document.getElementById(tableId + '-tHeadRow');
        tr.innerHTML += th;
    })
    var currentPage = 1;
    var pagination = Object.assign({}, paginationSetting);
    data.map(function(item,index){
        var itemCount = index + 1;
        if (itemCount > pagination.maxItem){
            currentPage = currentPage + 1;
            paginationSetting.pageNumber = currentPage;
            pagination.maxItem = pagination.maxItem + pagination.maxItem;
        }
        var tbody = document.getElementById(tableId + '-tBody');
        var tr = '<tr class="item-' + item.id + ' page page-' + currentPage + '" id="' + tableId + '-itemRow-' + (index + 1) +'"></tr>';
        tbody.innerHTML += tr;
        if (model.hilighter) {
            if (item[model.hilighter.basedOn] == model.hilighter.opt.value){
                $('.item-' + item.id).css('background', model.hilighter.opt.color)
            }
        }
        delete item.slug;
        var trElement = document.getElementById(tableId + '-itemRow-' + (index + 1));
        var propCount = 1;
        for (let prop in item){
            if (propCount == Object.keys(item).length){
                var td = '<td class="text-center"><p>' + item[prop] + '</p></td>';
                trElement.innerHTML += td;
                propCount = 1;
            } else {
                var td = '<td><p>' + item[prop] + '</p></td>';
                trElement.innerHTML += td;
                propCount ++
            }
        }
    })


    let tableRendered = new Event('tableRendered');
    document.dispatchEvent(tableRendered)
    setPagination(wrapper,tableId)
}

function reRenderTable(){
    switch (tabName) {
        case ('products'):
                getProducts(true);
            break;
        case ('orders'):
                getOrders(true);
            break;
        case ('store'):
                getStore(true);
            break;
        case ('shippings'):
                getShippings(true);
            break;
        case ('categories'):
                getCategories(true);
            break;
        case ('tecniques'):
                getUsers(true);
            break;
    }
}


//pagination

function setPagination(wrapper,tableId){
    $('.Page').remove();
    var currentPage = paginationSetting.currentPage
    $('.page').each(function(){
        if (!$(this).hasClass('page-' + currentPage)){
            $(this).hide();
        } else {
            $(this).show();
        }
    })
    var paginationRow = '<nav class="Page navigation"><ul class="justify-content-center pagination pagination-' + tableId + ' "></ul></nav>'

    wrapper.innerHTML += paginationRow;
    var prevButton = '<li class="page-item paginationPrev-' + tableId + '" onclick="paginationPrev()">';
        prevButton +=   '<a class="page-link" href="#" aria-label="Previous">';
        prevButton +=       '<span aria-hidden="true">&laquo;</span>';
        prevButton +=       '<span class="sr-only">Previous</span>';
        prevButton +=   '</a>';
        prevButton += '</li>';
    var nextButton = '<li class="page-item paginationNext-' + tableId + '" onclick="paginationNext()">';
        nextButton +=   '<a class="page-link" href="#" aria-label="Next">';
        nextButton +=       '<span aria-hidden="true">&raquo;</span>';
        nextButton +=       '<span class="sr-only">next</span>';
        nextButton +=   '</a>';
        nextButton += '</li>';
    var $pagination = document.getElementsByClassName("pagination-" + tableId)[0];

    $pagination.innerHTML += prevButton;
    for (var i = 0; i < paginationSetting.pageNumber; i++) {
        $pagination.innerHTML += '<li id="page-item-' + (Number(i) + 1) + '" class="page-item" onclick="paginationGoToPage(' + (Number(i) + 1)  +')"><a class="page-link" href="#">' + (Number(i) + 1) + '</a></li>';
    }
    $pagination.innerHTML += nextButton;
    if (paginationSetting.currentPage == 1){
        $('.paginationPrev-' + tableId).hide()
    }
    if (paginationSetting.currentPage == paginationSetting.pageNumber){
        $('.paginationNext-' + tableId).hide()
    }
    $('#page-item-' + paginationSetting.currentPage).addClass('active');
}

function paginationGoToPage(page){
    paginationSetting.currentPage = page;
    setPagination(tableWrapper,tableId)
}

function paginationNext(){
    paginationSetting.currentPage = paginationSetting.currentPage + 1;
    setPagination(tableWrapper,tableId)
}

function paginationPrev(){
    paginationSetting.currentPage = paginationSetting.currentPage - 1;
    setPagination(tableWrapper,tableId)
}
